import { Pipe, PipeTransform } from '@angular/core';
import { Monitor } from '../models/entities/monitor.type';

@Pipe({
  name: 'monitorTitleOnly'
})
export class TransformMonitorKeyToTitlePipe implements PipeTransform {

  transform(monitor: Monitor): string {
    if (!monitor) {
      return null;
    }

    return `<b>${monitor.Machine.Title}</b> - ${monitor.MonitorTitle}`;
  }
}
